export const environment = {
  production: true,
  backendUrl: 'https://apiv2.back2action.de/',
};



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/environments/environment.ts